"use client"

import { createBrowserClient } from "@supabase/ssr"
import { Button } from "@/components/ui/button"
import { LogOut } from "lucide-react"
import { useRouter } from "next/navigation"
import { toast } from "sonner"
import { useLanguage } from "@/lib/language-context"

export function SignOutButton() {
    const { t } = useLanguage()
    const router = useRouter()

    const handleLogout = async () => {
        try {
            const supabase = createBrowserClient(
                process.env.NEXT_PUBLIC_SUPABASE_URL!,
                process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
            )

            const { error } = await supabase.auth.signOut()
            if (error) {
                throw error
            }

            router.refresh()
            router.push("/login")
            toast.success(t("account.sign_out_success") || "Signed out successfully")
        } catch (error) {
            console.error("Error signing out:", error)
            toast.error(t("account.sign_out_error") || "Error signing out")
        }
    }

    return (
        <Button
            variant="outline"
            onClick={handleLogout}
            className="group gap-2 bg-white border-2 hover:bg-red-50 hover:text-red-600 hover:border-red-200 transition-all duration-300 font-bold px-6 h-11 rounded-xl shadow-sm"
        >
            <LogOut className="h-4 w-4 transform group-hover:-translate-x-1 transition-transform" />
            {t("account.sign_out")}
        </Button>
    )
}
